var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popper',{attrs:{"trigger":_vm.trigger,"options":_vm.options}},[_c('div',{staticClass:"popper"},[_vm._t("default")],2),_c('div',{attrs:{"slot":"reference"},slot:"reference"},[_vm._t("trigger")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }